<template>
    <div>
        <div class="page-title">
            <h4 v-if='this.post_service'> {{$t('txt.serviciuPostVanzare')}}: {{this.post_service.name}}</h4>
        </div>
        <div class="table-header edit-header">
            <div class="search-box" v-if="$can(['update service-ps'])">
                <router-link v-if='this.post_service' :to="{ name: 'editpostsaleservice', params: { id: post_service.id }}">
                    <button type="button" class="add-user edit-button">
                        <i class="far fa-edit"></i>
                        <span> {{$t('placeholder.editeaza')}} </span>
                    </button>
                </router-link>
            </div>
        </div>
        <form class="add-user-form">
            <div class="row">
                <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="account-detail-box">
                        <ul class="account-detail-list">
                            <sequential-entrance fromTop delay="70">
                                <li v-for="input_field in input_fields.column_1" :key="input_field.id">
                                  <div class="view-info-wrapper">
                                    <div class="contact-design">
                                      <i :class="input_field.icon"></i>
                                      <span> {{input_field.labelName}} </span>
                                    </div>
                                    <p> {{input_field.inputValue}} </p>
                                  </div>
                                </li>
                            </sequential-entrance>
                        </ul>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="account-detail-box">
                        <ul class="account-detail-list">
                            <sequential-entrance fromTop delay="70">
                                <li v-for="input_field in input_fields.column_2" :key="input_field.id">
                                  <div class="view-info-wrapper">
                                    <div class="contact-design">
                                      <i v-bind:class="input_field.icon"></i>
                                      <span> {{input_field.labelName}} </span>
                                    </div>
                                    <p> {{input_field.inputValue}} </p>
                                  </div>
                                </li>
                            </sequential-entrance>
                        </ul>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>

import PostServiceSservice from '../../api-services/post_services.service.js'

export default {
  name: 'viewpostservice',
  data () {
    return {
      post_service: null
    }
  },
  methods: {
    getPostService () {
      PostServiceSservice.get(this.$route.params.id)
        .then((response) => {
          this.$store.dispatch('hideLoading')
          this.post_service = response.data.data
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          console.log(error)
        })
    }
  },
  computed: {
    input_fields () {
      return {
        column_1: [
          {
            inputName: 'ord',
            labelName: this.$t('placeholder.ord'),
            inputValue: (this.post_service) ? this.post_service.ord : null,
            icon: 'fas fa-file-signature'
          },
          {
            inputName: 'name',
            labelName: this.$t('placeholder.nume'),
            inputValue: (this.post_service) ? this.post_service.name : null,
            icon: 'fas fa-donate'

          },
          {
            inputName: 'value',
            labelName: this.$t('placeholder.valoare'),
            inputValue: (this.post_service) ? this.post_service.value : null,
            icon: 'fas fa-money-bill-wave info-tool'
          }
        ],
        column_2: [
          {
            inputName: 'price',
            labelName: this.$t('placeholder.pret'),
            inputValue: (this.post_service) ? this.post_service.price : null,
            icon: 'fas fa-file-signature'
          }
        ]
      }
    }
  },
  mounted () {
    this.getPostService()
  }
}
</script>
